import { dateUtils } from '@utils';

/**
 * The report API filters on UTC timestamps, and the conversion is explicit in both
 * directions because the two ends are not symmetric.
 *
 * Going out, the offset is required. The composite service registers its own
 * String -> LocalDateTime converter built on `ISO_OFFSET_DATE_TIME`
 * (StaticResourceConfiguration#addFormatters), which rejects any value that omits the
 * zone, so the picked local day boundaries are sent as a full UTC instant with the `Z`
 * that `toISOString()` supplies.
 *
 * Do not "simplify" this by dropping the offset to match the order service. Order
 * registers the same converter with `ISO_LOCAL_DATE_TIME` and so rejects the offset
 * form, but nothing sends it one: composite binds to a LocalDateTime and the generated
 * order client re-serialises it with `LocalDateTime.toString()`, which has no offset.
 * The two ends disagree on the wire format and are only consistent through composite.
 *
 * Coming back, the timestamps are Java LocalDateTime values and serialise without any
 * zone, so `Z` has to be appended before parsing. Otherwise JavaScript reads them as local
 * time and the report shows UTC days rather than the viewer's own days.
 */

export const startOfDayUtcQueryParam = (date) => dateUtils.formatQueryParamDateBeginDayUTC(date);

export const endOfDayUtcQueryParam = (date) => dateUtils.formatQueryParamDateEndDayUTC(date);

export const parseUtcTimestamp = (value) => (value ? new Date(`${value}Z`) : null);
